module.exports = __webpack_public_path__ + "img/icon_highlight_niulong.294307ef.png";